import getBasePath from '../../../../common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'centro-custo');

const centroCustoActions = {
  ...genericActions(basePath),
  listarAtivos: { method: 'GET', url: `${basePath}?indAtivo=true` },
  listarAutocomplete: { method: 'GET', url: `${basePath}?autocomplete={autocomplete}&indAtivo=true` },
};

export default resource => resource(`${basePath}`, {}, centroCustoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/centro-custo.js